import { render, staticRenderFns } from "./groupRules.vue?vue&type=template&id=0e36dee3&"
import script from "./groupRules.vue?vue&type=script&lang=js&"
export * from "./groupRules.vue?vue&type=script&lang=js&"
import style0 from "./groupRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports